import React from "react";
import Card from "./Card";
import { FaPencilAlt } from "react-icons/fa";
import { FaPenNib } from "react-icons/fa";
import { AiFillLike } from "react-icons/ai";
import { MdOutlineSlowMotionVideo } from "react-icons/md";
import { RiRobot2Line, RiPrinterCloudLine } from "react-icons/ri";
import Slogan from "../images/atmospheric/slogan.png";

const WhyUs = () => {
  return (
    <div className="p-4 py-20 pb-10  specialBg">
      <h1
        data-aos="fade-down"
        data-aos-easing="ease-in-out"
        dir="rtl"
        className="font-bold  text-3xl md:text-5xl text-center gold-text "
      >
        קצת על דיגיטל פלוס
      </h1>
      <h2
        data-aos="fade-in"
        data-aos-easing="ease-in-out"
        dir="rtl"
        className=" font-light px-4 my-4 text-base md:text-2xl max-w-[1000px] mx-auto text-center text-mainColor "
      >
        למעלה מעשרים שנות ניסיון בתחום הפרסום והעיצוב הגרפי מעמידים אותנו בחזית
        היצירתיות והחדשנות. אנו מתמחים בעיצוב גרפי, כל סוגי ההדפסות, פרסומות
        וידאו לעסקים בבינה מלאכותית Ai. עבודתנו מלווה עסקים קטנים ובינוניים, כמו
        גם חברות מובילות בישראל, במסע לשדרוג התדמית והנוכחות שלהם בעולם התחרותי.
        כשאתם בוחרים בנו, אתם מבטיחים לעסק שלכם את כל הניסיון, המקצועיות
        והיצירתיות שצברנו.
      </h2>

      <img src={Slogan} alt="עיצוב גרפי | כל סוגי עבודות הדפוס | הפקת פרסומות וידאו בבינה מלאכותית" className="mx-auto my-6 max-w-[420px] w-full opacity-85" />

      <h2
        dir="rtl"
        className=" font-bold px-4 mt-8 text-lg md:text-xl max-w-[1000px] mx-auto text-center gold-text "
      >
        השירותים שלנו{" "}
      </h2>

      <div className="flex flex-wrap justify-center gap-4 max-w-[1200px] mt-8 p-4 mx-auto">
        <div className="flex flex-col md:flex-row lg:flex-row w-full md:w-1/2 lg:w-1/2">
          <div
            data-aos="fade-down"
            data-aos-easing="ease-in-out"
            className="w-full"
          >
            <Card
              header="עיצוב גרפי"
              text="איפה אתה רואה את העסק שלך? בכל פרט, בכל מודעה, בכל פוסט ברשתות החברתיות – עיצוב גרפי שמשאיר חותם. אנחנו כאן כדי לתרגם את החזון שלך למציאות, בעזרת צבעים,  קו עיצובי שמדבר בשפה שלך."
              icon={FaPenNib}
            />
          </div>
          <div
            data-aos="fade-down"
            data-aos-easing="ease-in-out"
            className="w-full"
          >
            <Card
              header="דפוס דיגיטלי"
              text="הדפסת כל סוגי עבודות הדפוס - מאריזות, קלפים ומדבקות ועד מחברות ממותגות, באיכות גבוהה ועיצוב מוקפד."
              icon={RiPrinterCloudLine}
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row lg:flex-row w-full md:w-1/2 lg:w-1/2">
          <div
            data-aos="fade-down"
            data-aos-easing="ease-in-out"
            className="w-full"
          >
            <Card
              header="AI סרטוני "
              text="הפקת סרטוני תדמית מותאמים אישית באמצעות בינה מלאכותית – בלי ימי צילום, תוצאה מקצועית שמושכת לקוחות."
              icon={RiRobot2Line}
            />
          </div>
          <div
            data-aos="fade-down"
            data-aos-easing="ease-in-out"
            className="w-full"
          >
            <Card
              header="מיתוג עסקי"
              text="מה הופך עסק למותג? אסטרטגיה נכונה, ביסוס ערכים ויצירת תדמית חיצונית בולטת המבדלת אותו מהמתחרים."
              icon={FaPencilAlt}
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row lg:flex-row w-full md:w-1/2 lg:w-1/2">
          <div
            data-aos="fade-down"
            data-aos-easing="ease-in-out"
            className="w-full"
          >
            <Card
              header="פרסום"
              text="כל קמפיין הוא הזדמנות להתחבר עם הלקוח שלך ברמה חדשה. אנחנו בונים פרסום שלא רק נשמע, אלא גם מרגש – מספר את הסיפור שלך בדרך שתיזכר, בכל ערוץ ובכל פורמט."
              icon={AiFillLike}
            />
          </div>
          <div
            data-aos="fade-down"
            data-aos-easing="ease-in-out"
            className="w-full"
          >
            <Card
              header="עריכת וידאו"
              text="מתמחים ביצירת פרסומות מרתקות ופוסטים מונפשים שמקנים חיים  לפוסטים . השירות שלנו מתאים למותגים שרוצים לבלוט בכל פלטפורמה."
              icon={MdOutlineSlowMotionVideo}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
